// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
    // Mobile menu toggle
    const menuToggle = document.querySelector('.menu-toggle');
    const navLinks = document.querySelector('.nav-links');
    const dropdowns = document.querySelectorAll('.dropdown');

    if (menuToggle && navLinks) {
        menuToggle.addEventListener('click', function() {
            navLinks.classList.toggle('active');
            menuToggle.classList.toggle('active');
        });

        // Close menu when clicking outside
        document.addEventListener('click', function(e) {
            if (!navLinks.contains(e.target) && !menuToggle.contains(e.target)) {
                navLinks.classList.remove('active');
                menuToggle.classList.remove('active');
            }
        });
    }

    // Handle dropdowns in mobile view
    dropdowns.forEach(dropdown => {
        dropdown.addEventListener('click', function(e) {
            if (window.innerWidth <= 768) {
                e.preventDefault();
                this.classList.toggle('active');
            }
        });
    });

    // Close mobile menu when clicking on a link
    document.querySelectorAll('.nav-links a').forEach(link => {
        link.addEventListener('click', () => {
            menuToggle.classList.remove('active');
            navLinks.classList.remove('active');
        });
    });
    
    // Navbar scroll effect
    const navbar = document.querySelector('.navbar');
    if (navbar) {
        window.addEventListener('scroll', function() {
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        });
    }
    
    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;
            
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 80,
                    behavior: 'smooth'
                });
            }
        });
    });
    
    // Initialize scroll reveal animations
    initScrollReveal();

    // Handle animations on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        document.body.classList.add('resize-animation-stopper');
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            document.body.classList.remove('resize-animation-stopper');
        }, 400);
    });

    // Contact Form Handling
    const contactForm = document.getElementById('contactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', async function(e) {
            e.preventDefault();
            
            // Basic form validation
            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            const message = document.getElementById('message').value;
            
            if (!name || !email || !message) {
                alert('Please fill in all required fields');
                return;
            }

            // Add loading state to button
            const submitButton = contactForm.querySelector('button[type="submit"]');
            submitButton.disabled = true;
            submitButton.innerHTML = 'Sending...';

            try {
                // Here you would typically send the form data to your server
                // For now, we'll just simulate a submission
                await new Promise(resolve => setTimeout(resolve, 1000));
                alert('Thank you for your message. We will contact you soon!');
                contactForm.reset();
            } catch (error) {
                alert('There was an error sending your message. Please try again.');
            } finally {
                submitButton.disabled = false;
                submitButton.innerHTML = 'Send Message';
            }
        });
    }

    // Intersection Observer for scroll animations
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, { threshold: 0.1 });

    // Observe all animated elements
    document.querySelectorAll('.animate-from-left, .animate-from-right, .animate-from-bottom')
        .forEach(el => observer.observe(el));
});

// Enhanced Scroll Reveal Animation
function initScrollReveal() {
    const animateElements = document.querySelectorAll(
        '.animate-from-bottom, .animate-from-left, .animate-from-right, .reveal'
    );
    
    const options = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                // Optional: Reset animation when element is out of view
                // } else {
                //     entry.target.classList.remove('active');
            }
        });
    }, options);
    
    animateElements.forEach(element => {
        observer.observe(element);
        // Add initial state class
        element.classList.add('animate-init');
    });
}
  // Additional animation for floating contacts on scroll
        window.addEventListener('scroll', function() {
            const floatingContacts = document.querySelector('.floating-contacts');
            const contactHero = document.querySelector('.contact-hero');
            const heroHeight = contactHero.offsetHeight;
            const scrollPosition = window.scrollY;
            
            if (scrollPosition > heroHeight * 0.3) {
                floatingContacts.style.transform = 'translateY(0) scale(0.9)';
                floatingContacts.style.opacity = '0.9';
            } else {
                floatingContacts.style.transform = 'translateY(0) scale(1)';
                floatingContacts.style.opacity = '1';
            }
        });

// Initialize animations after page load
window.addEventListener('load', initScrollReveal);